/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RetryUnknownStatePaymentsDto
 */
export interface RetryUnknownStatePaymentsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof RetryUnknownStatePaymentsDto
     */
    paymentIds: Array<number>;
}

/**
 * Check if a given object implements the RetryUnknownStatePaymentsDto interface.
 */
export function instanceOfRetryUnknownStatePaymentsDto(value: object): value is RetryUnknownStatePaymentsDto {
    if (!('paymentIds' in value) || value['paymentIds'] === undefined) return false;
    return true;
}

export function RetryUnknownStatePaymentsDtoFromJSON(json: any): RetryUnknownStatePaymentsDto {
    return RetryUnknownStatePaymentsDtoFromJSONTyped(json, false);
}

export function RetryUnknownStatePaymentsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetryUnknownStatePaymentsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentIds': json['paymentIds'],
    };
}

export function RetryUnknownStatePaymentsDtoToJSON(json: any): RetryUnknownStatePaymentsDto {
    return RetryUnknownStatePaymentsDtoToJSONTyped(json, false);
}

export function RetryUnknownStatePaymentsDtoToJSONTyped(value?: RetryUnknownStatePaymentsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentIds': value['paymentIds'],
    };
}

